import { PlusThinLined } from '@tag/tag-icons';

import styles from './plus-icon.module.scss';

export default function PlusIcon() {
  return (
    <div className={styles.wrapper}>
      <PlusThinLined
        accent="white"
      />
    </div>
  );
}
